import{createContext as o}from"react";const e=o({openModal:()=>{},closeModal:()=>{}});export{e as ModalMessageContext};
//# sourceMappingURL=ModalMessageContext.js.map
